import { LOCATION_TYPE } from "~/views/order/vmcOrder/VMCController";
import { NETWORK_TYPE } from "../Edge";

export interface VMCConfig {
    tenantId: string;
    serviceInstanceName: string;
    serviceInstanceDisplayName: string;
    serviceType: string;
    serviceInstanceLocationType: string;
    serviceInstanceLocation: string;
    serviceInstanceLatitude?: number;
    serviceInstanceLongitude?: number;

    deploymentCloudId?: string;

    /** For Service Type = Private , will need mcc , mnc , tac */
    mcc: string;
    mnc: string;
    tac: number;
    release: string;
    releaseTag: string;
}

export const VMCConfigDefault: VMCConfig = {
    tenantId: "",
    serviceInstanceName: "",
    serviceInstanceDisplayName: "",
    serviceType: "Private",
    serviceInstanceLocationType: "GCP",
    serviceInstanceLocation: "us-central1-c",

    mcc: "315",
    mnc: "010",
    tac: 63,
    release: "",
    releaseTag: "",
}

export type EDGE_FORM_FACTOR = "VM" | "BAREMETAL";

export interface EdgeConfig {
    edgeName: string;
    edgeInterfaceCount: number;
    edgeLocationType: string;
    edgeLocation: string;

    networkType: NETWORK_TYPE;


    edgeIpsecMode: boolean;
    networkMode: string;

    edgeRelease: string;
    edgeReleaseTag: string;
    services: string;

    // for private cloud
    edgeLatitude?: number;
    edgeLongitude?: number;
    formFactor?: EDGE_FORM_FACTOR;

}
export const EdgeConfigDefault: EdgeConfig = {
    edgeName: "Edge-001",
    edgeInterfaceCount: 2,
    edgeLocationType: LOCATION_TYPE.PRIVATE_CLOUD,
    edgeLocation: "",
    edgeIpsecMode: true,
    networkMode: "GATEWAY",
    networkType: "4G",
    formFactor: "VM",

    edgeRelease: "",
    edgeReleaseTag: "",
    services: "PRIVATE_CELLULAR",
}


export interface RadioConfig {

    RadioName: string;
    RadioAltitude: number;
    RadioLatitude?: number;
    RadioLongitude?: number;
    RadioLocation?: string;
    RadioLocationSyncMode: string;
}

export const RadioConfigDefault: RadioConfig = {
    RadioName: "Radio-001",
    RadioAltitude: 0,
    RadioLatitude: 0,
    RadioLongitude: 0,
    RadioLocationSyncMode: "MANUAL",
    RadioLocation : ""
}


export interface DeviceConfig {
    /** Based on the operator / tenant / custom */
    imsiMgmtType: string;

    subscriberCount: number;
    esimCount: number;

    // if Mgmt is OPERATOR
    /** Based - BLOCK / ICCID */
    psimAllocationType?: string;
    /**  if ICCID list, generate psimIccidNumber$[index] */
    psimIccidNumberList?: string[];

    // if allocation type is BLOCK
    psimBlockId?: string;
    esimBlockId?: string;
}

export const DeviceConfigDefault: DeviceConfig = {
    subscriberCount: 0,
    esimCount: 0,
    imsiMgmtType: "OPERATOR",
    psimAllocationType: "BLOCK",

}

export interface OrderConfig {
    vmc: VMCConfig;
    edge: EdgeConfig;
    radio: RadioConfig;
    device: DeviceConfig;
}

export const orderConfigDefault: OrderConfig = {
    vmc: VMCConfigDefault,
    edge: EdgeConfigDefault,
    radio: RadioConfigDefault,
    device: DeviceConfigDefault,
};